import React from 'react'
import governmentIcon from './Images/Government.png';
import d2cIcon from './Images/D2C brand.png';
import healthcareIcon from './Images/Healthcare.png';
import educationIcon from './Images/Education.png';
import agricultureIcon from './Images/Agriculture.png';
import smartCitiesIcon from './Images/SmartCities.png';
import sectorsIcon from './Images/sectorsIcon.png';
import { useNavigate } from "react-router-dom";

const items = [
    { icon: governmentIcon, label: 'Government' },
    { icon: d2cIcon, label: 'D2C brand' },
    { icon: healthcareIcon, label: 'Healthcare' },
    { icon: educationIcon, label: 'Education' },
    { icon: agricultureIcon, label: 'Agriculture' },
    { icon: smartCitiesIcon, label: 'Smart Cities' },
];

const MiniButton = ({ src, alt, text }) => (
    <div
        style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            padding: '8px 18px',
            borderRadius: '8px',
            border: '1px solid #e7eefcff',
            background: 'linear-gradient(180deg, #F4F7FC 0%, #EAF2FF 100%)',
            cursor: 'pointer',
            minHeight: 48,
            flex: '0 0 auto'
        }}
    >
        <img src={src} alt={alt} style={{ width: 26, height: 26 }} />
        <span
            style={{
                fontSize: 16,
                fontWeight: 550,
                color: '#0F1C2E',
                whiteSpace: 'nowrap'
            }}
        >
            {text}
        </span>
    </div>
);

const HeroSectionScroll = () => {
    const navigate = useNavigate();

    return (
        <section className="py-4 position-relative" style={{ overflow: 'hidden' }}>
            <div
                className="px-5 x-xxl-5 px-6 mx-auto position-relative"
                style={{
                    maxWidth: '74%',
                    zIndex: 1,
                    marginTop: 10
                }}
            >
                {/* Heading */}
                <div>
                    <h2
                        style={{
                            fontSize: "2.5rem",
                            fontFamily: "Inter",
                            fontWeight: 700,
                            color: "#242121ff",
                            lineHeight: 1.2,
                        }}
                    >
                        Build for every industry, made to scale
                    </h2>
                    <p
                        className="mt-2"
                        style={{
                            marginTop: -2,
                            color: "#413e3eff",
                            fontSize: "1.1rem",
                            fontFamily: "Poppins",
                            fontWeight: 300,
                            lineHeight: 1.2,
                        }}
                    >
                        From startups to enterprises, our platform adapts to your workflows, goals and growth.
                    </p>
                </div>

                {/* Card box */}
                <div
                    style={{
                        marginTop: '24px',
                        background: '#F9F8F8',
                        borderRadius: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        padding: '16px',
                        position: 'relative',
                        overflow: 'hidden',
                        height: '100px',
                        gap: '16px'
                    }}
                >
                    {/* Left colored bar */}
                    <div
                        style={{
                            width: '10px',
                            height: '100%',
                            background: '#095092',
                            position: 'absolute',
                            left: 0,
                            top: 0,
                            bottom: 0,
                        }}
                    />

                    {/* Fixed "Sectors" label (icon + text) */}
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10,
                            marginLeft: 28,
                            flex: '0 0 auto',
                            zIndex: 1
                        }}
                    >
                        <img
                            src={sectorsIcon}
                            alt="Sectors"
                            style={{ width: 22, height: 22, objectFit: 'contain' }}
                        />
                        <span
                            style={{
                                fontFamily: "'Inter', sans-serif",
                                fontSize: 18,
                                fontWeight: 600,
                                color: '#0F1C2E',
                                letterSpacing: '.2px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Sectors
                        </span>
                    </div>

                    {/* Scrolling viewport */}
                    <div
                        style={{
                            flex: 1,
                            overflow: 'hidden',
                            position: 'relative',
                            maskImage:
                                'linear-gradient(to right, transparent 0, black 24px, black calc(100% - 24px), transparent 100%)',
                            WebkitMaskImage:
                                'linear-gradient(to right, transparent 0, black 24px, black calc(100% - 24px), transparent 100%)',
                        }}
                    >
                        <div
                            className="auto-track"
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '20px',
                                whiteSpace: 'nowrap',
                                willChange: 'transform'
                            }}
                        >
                            {items.map((it, i) => (
                                <MiniButton key={`a-${i}`} src={it.icon} alt={it.label} text={it.label} />
                            ))}
                            {items.map((it, i) => (
                                <MiniButton key={`b-${i}`} src={it.icon} alt={it.label} text={it.label} />
                            ))}
                        </div>
                    </div>

                    {/* View more (plain text, right-aligned inside card) */}
                    <span
                        onClick={() => navigate("/usecases")}
                        style={{
                            flex: '0 0 auto',
                            fontSize: 16,
                            fontWeight: 600,
                            color: "#054E91",
                            fontFamily: "'Inter', sans-serif",
                            cursor: "pointer",
                            whiteSpace: "nowrap"
                        }}
                    >
                        View more ➜
                    </span>
                </div>
            </div>

            {/* Auto-scroll animation */}
            <style>{`
              @keyframes scrollLeftInfinite {
              0%   { transform: translateX(0); }
              100% { transform: translateX(-50%); }
             }
            .auto-track { animation: scrollLeftInfinite 8s linear infinite; }
            .auto-track:hover { animation-play-state: paused; }

      `}</style>
        </section>
    );
}

export default HeroSectionScroll;
